export default __webpack_public_path__ + "static/media/icon-comment.252f79be.svg";